"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty3(e, r, t) { return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.VisitProcessor = void 0;
var _pageView = require("./pageView"),
  _types = require("./types"),
  _customData = require("./customData"),
  _conversion = require("./conversion"),
  _browser = require("./browser"),
  _device = require("./device"),
  _operatingSystem = require("./operatingSystem"),
  _geolocation = require("./geolocation"),
  _visitsData = require("./visitsData"),
  _kameleoonConversionScore = require("./kameleoonConversionScore"),
  _types2 = require("../types");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var VisitProcessor = /*#__PURE__*/function () {
  function VisitProcessor(a) {
    _classCallCheck(this, VisitProcessor);
    var b = a.filters,
      c = a.dataManager,
      d = a.visitorCode;
    _defineProperty(this, "visitsData", new _visitsData.VisitsData([])), _defineProperty(this, "visitorData", []), _defineProperty(this, "storageVisitorData", []), _defineProperty(this, "experimentData", {}), _defineProperty(this, "filters", void 0), _defineProperty(this, "visitorDataTypes", void 0), _defineProperty(this, "dataManager", void 0), _defineProperty(this, "singleDataTypes", _defineProperty3(_defineProperty3(_defineProperty3(_defineProperty3(_defineProperty3({}, _types.KameleoonData.Device, null), _types.KameleoonData.Browser, null), _types.KameleoonData.GeolocationData, null), _types.KameleoonData.OperatingSystem, null), _types.KameleoonData.KameleoonConversionScore, null)), _defineProperty(this, "multipleDataTypes", _defineProperty3(_defineProperty3(_defineProperty3({}, _types.KameleoonData.CustomData, new Map()), _types.KameleoonData.PageView, new Map()), _types.KameleoonData.Conversion, new Map())), this.filters = b, this.dataManager = c, this.visitorDataTypes = c.getVisitorStoredDataTypes(d);
  }
  return _createClass(VisitProcessor, [{
    key: "data",
    get: function get() {
      return {
        visitorData: this.visitorData,
        storageVisitorData: this.storageVisitorData,
        visitsData: this.visitsData,
        experimentData: this.experimentData
      };
    }
  }, {
    key: "processVisit",
    value: function processVisit(a) {
      this.processBrowser(a), this.processDevice(a), this.processOperatingSystem(a), this.processGeolocationData(a), this.processCustomData(a), this.processConversion(a), this.processPageView(a), this.processExperiments(a), this.processVisitsData(a);
    }
  }, {
    key: "processMultipleDataTypes",
    value: function processMultipleDataTypes() {
      var _this = this;
      for (var _i = 0, _Object$entries = Object.entries(this.multipleDataTypes); _i < _Object$entries.length; _i++) {
        var _ref = _Object$entries[_i];
        var _ref2 = _slicedToArray(_ref, 2);
        var a = _ref2[0];
        var b = _ref2[1];
        if (b.size) switch (a) {
          case _types.KameleoonData.PageView:
            {
              var _this$visitorData, _this$storageVisitorD;
              (_this$visitorData = this.visitorData).push.apply(_this$visitorData, _toConsumableArray(b.values())), (_this$storageVisitorD = this.storageVisitorData).push.apply(_this$storageVisitorD, _toConsumableArray(b.values()));
              break;
            }
          case _types.KameleoonData.Conversion:
            {
              var _this$storageVisitorD2;
              (_this$storageVisitorD2 = this.storageVisitorData).push.apply(_this$storageVisitorD2, _toConsumableArray(b.values()));
              break;
            }
          case _types.KameleoonData.CustomData:
            {
              b.forEach(function (a) {
                _this.visitorData.push(a), _this.dataManager.storedCustomDataIndexes.has(a.data.index) || _this.storageVisitorData.push(a);
              });
              break;
            }
        }
      }
    }
  }, {
    key: "processKcs",
    value: function processKcs(a) {
      if (this.filters.kcs && a) {
        var b = new _kameleoonConversionScore.KameleoonConversionScore(a);
        this.storageVisitorData.push(b);
      }
    }
  }, {
    key: "processBrowser",
    value: function processBrowser(a) {
      if (this.filters.browser && !this.singleDataTypes[_types.KameleoonData.Browser]) {
        var b = _browser.Browser._fromVisit(a);
        b && (!this.visitorDataTypes.has(_types.KameleoonData.Browser) && this.storageVisitorData.push(b), this.visitorData.push(b), this.singleDataTypes[_types.KameleoonData.Browser] = b);
      }
    }
  }, {
    key: "processDevice",
    value: function processDevice(a) {
      if (this.filters.device && !this.singleDataTypes[_types.KameleoonData.Device]) {
        var b = _device.Device._fromVisit(a);
        b && (!this.visitorDataTypes.has(_types.KameleoonData.Device) && this.storageVisitorData.push(b), this.visitorData.push(b), this.singleDataTypes[_types.KameleoonData.Device] = b);
      }
    }
  }, {
    key: "processOperatingSystem",
    value: function processOperatingSystem(a) {
      if (this.filters.operatingSystem && !this.singleDataTypes[_types.KameleoonData.OperatingSystem]) {
        var b = _operatingSystem.OperatingSystem._fromVisit(a);
        b && (!this.visitorDataTypes.has(_types.KameleoonData.OperatingSystem) && this.storageVisitorData.push(b), this.visitorData.push(b), this.singleDataTypes[_types.KameleoonData.OperatingSystem] = b);
      }
    }
  }, {
    key: "processGeolocationData",
    value: function processGeolocationData(a) {
      if (this.filters.geolocation && !this.singleDataTypes[_types.KameleoonData.GeolocationData]) {
        var b = _geolocation.GeolocationData._fromVisit(a);
        b && (!this.visitorDataTypes.has(_types.KameleoonData.GeolocationData) && this.storageVisitorData.push(b), this.visitorData.push(b), this.singleDataTypes[_types.KameleoonData.GeolocationData] = b);
      }
    }
  }, {
    key: "processCustomData",
    value: function processCustomData(a) {
      this.filters.customData && _customData.CustomData._updateFromVisit(a, this.multipleDataTypes[_types.KameleoonData.CustomData]);
    }
  }, {
    key: "processConversion",
    value: function processConversion(a) {
      if (this.filters.conversions) {
        var _this$visitorData2;
        _conversion.Conversion._updateFromVisit(a, this.multipleDataTypes[_types.KameleoonData.Conversion]);
        var b = _conversion.Conversion._listFromVisit(a);
        b.length && (_this$visitorData2 = this.visitorData).push.apply(_this$visitorData2, _toConsumableArray(b));
      }
    }
  }, {
    key: "processPageView",
    value: function processPageView(a) {
      this.filters.pageViews && _pageView.PageView._updateFromVisit(a, this.multipleDataTypes[_types.KameleoonData.PageView]);
    }
  }, {
    key: "processExperiments",
    value: function processExperiments(a) {
      if (this.filters.experiments && a.experimentEvents) {
        var _iterator = _createForOfIteratorHelper(a.experimentEvents),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var b = _step.value;
            var _b$data = b.data,
              _a = _b$data.id,
              c = _b$data.variationId;
            this.experimentData[_a] = {
              variationId: c,
              isTargetedRule: !1,
              status: _types2.TrackingStatus.Unsent
            };
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "processVisitsData",
    value: function processVisitsData(a) {
      this.visitsData.timestamp = a.timeStarted;
    }
  }, {
    key: "processMappingIdentifier",
    value: function processMappingIdentifier(a) {
      var b, c;
      if (a) {
        var d = null === (b = a.customDataEvents) || void 0 === b || null === (c = b.find(function (a) {
          return a.data.mappingIdentifier;
        })) || void 0 === c ? void 0 : c.time;
        if (d && a.visitorCode) return {
          mappingIdentifier: a.visitorCode,
          timestamp: d
        };
      }
    }
  }]);
}();
exports.VisitProcessor = VisitProcessor;